import { keyframes } from '@emotion/core'

import { PopoverBannerPosition } from '../types/popoverBannerPosition'

const bannerAnimationOptions = {
  opacityFrom: 'opacity: 0;',
  opacityTo: 'opacity: 1;',
  translateX: `translateX(-50%)`,
  translateY: `translateY(-50%)`,
}

interface AnimationPositionStyles {
  from: string
  to: string
}

export const animationPositionMap: Record<PopoverBannerPosition, AnimationPositionStyles> = {
  top: {
    from: `${bannerAnimationOptions.opacityFrom} transform: ${bannerAnimationOptions.translateX} translateY(-30px);`,
    to: `${bannerAnimationOptions.opacityTo} transform: ${bannerAnimationOptions.translateX} translateY(0);`,
  },
  bottom: {
    from: `${bannerAnimationOptions.opacityFrom} transform: ${bannerAnimationOptions.translateX} translateY(30px);`,
    to: `${bannerAnimationOptions.opacityTo} transform: ${bannerAnimationOptions.translateX} translateY(0);`,
  },
  left: {
    from: `${bannerAnimationOptions.opacityFrom} transform: ${bannerAnimationOptions.translateY} translateX(-30px);`,
    to: `${bannerAnimationOptions.opacityTo} transform: ${bannerAnimationOptions.translateY} translateX(0);`,
  },
  right: {
    from: `${bannerAnimationOptions.opacityFrom} transform: ${bannerAnimationOptions.translateY} translateX(30px);`,
    to: `${bannerAnimationOptions.opacityTo} transform: ${bannerAnimationOptions.translateY} translateX(0);`,
  },
}

export const getBannerAnimation = (position: PopoverBannerPosition) => {
  const { from, to } = animationPositionMap[position]
  return keyframes`
    from { ${from} }
    to { ${to} }
  `
}
